export default "__VITE_ASSET__CIXOSghG__"